import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getPreviewName } from '../../utils/nameFormat';
export const removePreviewFieldStmtInstruction = `
#### Remove preview field

- Syntax: \`remove previewField <field_name> in <preview_name>;\`
- Example: \`remove previewField name in ${getPreviewName('Option')};\` (to remove a name field or column, now referred to as an element, in a product list view).
- Example: \`remove previewField category.name in ${getPreviewName('Variant')};\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
`;
export const stmtRemovePreviewField = ({ previewFieldName, previewName }) => {
    return `remove previewField ${previewFieldName} in ${previewName};`;
};
export const removePreviewFieldHandler = createStructureStatementHandler({
    type: 'remove previewField',
    parse: line => {
        const match = /^remove previewField (?<previewFieldName>[\w.]+) in (?<previewName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove previewField',
                previewFieldName: match.groups.previewFieldName,
                previewName: match.groups.previewName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removePreviewField({
                previewFieldName: stmt.previewFieldName,
                previewName: stmt.previewName,
            });
        });
    },
});
//# sourceMappingURL=RemovePreviewFieldStmt.js.map